<div aria-labelledby="inlcudes-tab" class="tab-pane tab-content fade" id="faq" role="tabpanel">
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="error-list" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p>{{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-block">
            <form>
                <div class="form-modified">

                    <div class="row">
                        <div class="col-lg-8 offset-2">
                            <div class="empty-data green">
                                <p>
                                    FAQ for hotel.
                                </p>
                            </div>
                            <div class="mb-3" v-if="!ui.status.canAdd">
                                <a @click.prevent="showAddFaqButton()" class="btn default-btn" href=""><i class="fas fa-plus"></i> Add new FAQ</a
                                >
                            </div>
                        </div>
                    </div>

                    <div class="form-group row" v-if="ui.status.canAdd">
                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            FAQ</label
                        >
                        <div class="col-sm-8">
                             <div class="form-group">
                   <input type="text" class="form-control"
                        :class="{ 'error-input' : ui.error.errors['question'] }"
                        id=""
                        name=""
                        placeholder="eg. faq question Here."
                        v-model="item.addFaq.question"
                ></input>
                                <validation-error
                                        :errors="ui.error.errors"
                                        :field="'question'"
                                        :isError="ui.error.has_error"
                                        v-if="ui.error.has_error"
                                />
                            </div>
                            <div class="form-group">
                   <textarea
                        :class="{ 'error-input' : ui.error.errors['answer'] }"
                        id=""
                        name=""
                        placeholder="eg. faq answer Here."
                        v-model="item.addFaq.answer"
                ></textarea>
                                <validation-error
                                        :errors="ui.error.errors"
                                        :field="'answer'"
                                        :isError="ui.error.has_error"
                                        v-if="ui.error.has_error"
                                />
                            </div>

                           
                        </div>
                        <div class="col-sm-2">
                            <a
                                    @click.prevent="addIncludes"
                                    class="btn btn-sm add-btn"
                                    href="#"
                                    role="button"
                            >{{buttonTextAddFaq}}
                                <spinner
                                        :loading="ui.status.postLoading.create"
                                        v-if="ui.status.postLoading.create"
                                ></spinner>
                            </a>
                            </div>
                        </div>
                        <div :key="index" class="form-group row" v-for="(list, index) in item.faqList">
                            <div class="col-lg-8 offset-lg-2">
                                <div class="empty-data">
                                    <p v-if="item.faqList.length == 0">
                                        No Faq List
                                    </p>
                                </div>

                                <div class="includes-list-item">
                                    <div class="includes-list hoverable-list readonly" v-if="!list.IsActive">
                                        <!-- <label class="readonly"><span v-if="list.icon">{{list.icon.name}}</span></label> -->

                                        <div class="includes-description">
                                            <p>{{ list.question }}</p>
                                        </div>

                                        <!-- delete modals -->
                                    </div>

                                    <div class="includes-list editable" v-if="list.IsActive">
                                        <div class="row">
                                            <div class="col-lg-10">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" :class="{ 'error-input' : ui.error.errors['question'] }" id="" name="" placeholder="eg. faq question Here." v-model="list.question"></input>
                                                    <validation-error :errors="ui.error.errors" :field="'question'" :isError="ui.error.has_error" v-if="ui.error.has_error" />
                                                </div>
                                                <div class="form-group">
                                                    <textarea :class="{ 'error-input' : ui.error.errors['answer'] }" id="" name="" placeholder="eg. answer Here." v-model="list.answer"></textarea>
                                                    <validation-error :errors="ui.error.errors" :field="'answer'" :isError="ui.error.has_error" v-if="ui.error.has_error" />

                                                </div>
                                            </div>

                                            <div class="col-lg-2">
                                                <div class="includes-action justify-content-start">
                                                    <button @click.prevent="editFaq()" class="btn green" type="button" v-if="list.IsActive">
                                                    <i class="fas fa-save"></i>
                                                </button>
                                                    <button @click.prevent="cancelFaq(index, list)" class="btn red" type="button" v-if="list.IsActive">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class="includes-action">
                                    <button @click.prevent="onEditFaqClick(index, list)" class="btn blue" type="button" v-if="!ui.status.canEdit">
                                    <i class="fas fa-pen"></i>
                                </button>
                                    <button @click.prevent="onDeleteFaqClick(index, list)" class="btn red" type="button">
                                    <i class="fas fa-minus"></i>
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
            </form>

            <div class="modal-wrap">
                <div aria-labelledby="exampleModalLabel" class="modal fade show" id="deleteSelectedFaq" role="dialog" tabindex="-1">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Delete FAQ</h5>
                                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="error-list" v-if="ui.error.modal.delete">
                                <ul class="error-msg">
                                    <li :key="x" v-for="(error,x) in ui.error.modal.delete">
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                            <div class="modal-body">
                                <p>
                                    Are you sure you want to delete this ?
                                </p>
                            </div>

                            <div class="modal-footer">
                                <button @click.prevent="deleteFaq()" class="btn default-btn" type="button">
                                    Ok
                                    <spinner :loading="ui.status.postLoading.delete" v-if="ui.status.postLoading.delete"></spinner>
                                </button>
                                <button :disabled="ui.status.postLoading.delete" @click.prevent="hideDeleteModal" aria-label="Close" class="btn default-btn cancel" type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>